/// <reference path="./meevoTheming.section.base.ts" />

module Meevo.Plugins.MeevoTheming {
    "use strict";
    import BusinessInfoDataService = Meevo.Components.Common.BusinessInfoDataService;
    /**
    * Main Section of Meevo Color Themes
    */
    export class MainSection extends MeevoThemingSectionBase {
        protected $http: angular.IHttpService;
        private taskbarColor: string;
        private taskbarTabsColor: string;
        private previousColors: {
            taskbarColor: string,
            taskbarTabsColor: string,
            menuTheme: any,
        }
        private selected_menu_theme: number;
        private respObj: any;
        public saveFunction: any;
        public cancelFunction: any;
        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            context: MeevoThemingContext,
            saveFunction: any,
            cancelFunction: any,
            sectionSecurityKey?: string,
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, context, saveFunction, cancelFunction, sectionSecurityKey);
            let uri = `/storagedrv/${this.tenantId}/styles/meevo.json`
            this.dataService.customMethodData(uri, 'GET', '', '')
                .then((response) => {
                    this.respObj = response.data;

                    this.model = response.data;
                    this.activate();

                   
                   //     this.initializeHeader(data);
                   


                    let colors = this.respObj["colors"];
                    this.previousColors = {
                        taskbarColor: colors["taskbarColor"],
                        taskbarTabsColor: colors["taskbarTabsColor"],
                        menuTheme: colors["menuTheme"]? colors["menuTheme"] : 0,
                    };

                    //checking for AWS taskbar Colors
                    if (colors.taskbarColor) {
                        this.taskbarColor = colors["taskbarColor"];
                        this.previousColors.taskbarColor = colors["taskbarColor"];
                    } else {
                        this.taskbarColor = "#5E35B1";
                        this.previousColors.taskbarColor = "#5E35B1";
                        this.respObj.colors["taskbarColor"] = "#5E35B1"
                    }
                    if (colors.taskbarTabsColor) {
                        this.taskbarTabsColor = colors['taskbarTabsColor'];
                        this.previousColors.taskbarTabsColor = colors["taskbarTabsColor"];
                    } else {
                        this.taskbarTabsColor = "#D10BB5";
                        this.previousColors.taskbarTabsColor = "#D10BB5";
                        this.respObj.colors["taskbarTabsColor"] = "#D10BB5"
                    }
                    //Checking for menu theming
                    if (colors.menuTheme) {
                        this.selected_menu_theme = colors.menuTheme;
                    } else {
                        this.selected_menu_theme = 0;
                    }


                }).catch((err: any) => { console.log("getThemeCssError"); });
        }

        activate(): void {
            super.activate();
        }


        transitionTime = '1s';
        menu_themes = [

            {//default
                click: "#863b96",
                hover: "rgba(134, 59, 150, 0.5)",
                background: "rgb(29, 12, 68, 0.5)",
                button: 0,
                onHover: {
                    0: false,
                    1: false,
                    2: false,
                }
            },
            {//black
                click: "#8c8c8c",
                hover: "rgb(140, 140, 140,0.5)",
                background: "rgb(0, 0, 0,0.2)",
                button: 0,
                onHover: {
                    0: false,
                    1: false,
                    2: false,
                }
            },
            {//earth
                click: "rgb(135, 125, 116)",
                hover: "rgb(135, 125, 116,0.5)",
                background: "rgb(48, 42, 37,0.6)",
                button: 0,
                onHover: {
                    0: false,
                    1: false,
                    2: false,
                }
            },
            {//earth green
                click: "rgb(107, 148, 70)",
                hover: "rgb(107, 148, 70, 0.5)",
                background: "rgb(26,41,13,0.6)",
                button: 0,
                onHover: {
                    0: false,
                    1: false,
                    2: false,
                }
            },
            {//teal
                click: "#3d829e",
                hover: "rgb(61, 130, 159, 0.5)",
                background: "rgb(0,32,42,0.7)",
                button: 0,
                onHover: {
                    0: false,
                    1: false,
                    2: false,
                }
            },
            {//blue
                click: "#3b509f",
                hover: "rgb(59, 80, 159, 0.5)",
                background: "rgb(0,4,46,0.5)",
                button: 0,
                onHover: {
                    0: false,
                    1: false,
                    2: false,
                }
            },
            {//orange
                click: "#cd7516",
                hover: "rgb(205, 117, 22, 0.5)",
                background: "rgb(176,120,23,0.5)",
                button: 0,
                onHover: {
                    0: false,
                    1: false,
                    2: false,
                }
            },
            {//pink
                click: "#a43983",
                hover: "rgb(164, 57, 131, 0.5)",
                background: "rgb(36,4,30,0.7)",
                button: 0,
                onHover: {
                    0: false,
                    1: false,
                    2: false,
                }
            },
            {//red
                click: "#942d2d",
                hover: "rgb(148, 45, 45, 0.5)",
                background: "rgba(36,0,0,0.5)",
                button: 0,
                onHover: {
                    0: false,
                    1: false,
                    2: false,
                }
            },

        ]

        getMenuTheme(menuTheme) {

            let hover = "theming_menu_option > div:hover{`${menuTheme.hover}`}";
            let background = "";
            let click = "";

            return hover;
        }
        getMenuClick(menuTheme, buttonNumber, readOnly) {
            if (readOnly) {
                return;
            }
            menuTheme.button = buttonNumber;
            return "";
        }
        checkMenuClick(menuTheme, buttonNumber) {
            return menuTheme.button === buttonNumber;
        }
        OnMenuHover(menuTheme, buttonNumber, enter, readOnly) {
            if (readOnly) {
                return;
            }
            if (enter) {
                menuTheme.onHover[buttonNumber] = true;
            } else {
                menuTheme.onHover[buttonNumber] = false;
            }
        }
        checkHover(menuTheme, buttonNumber) {
            return menuTheme.onHover[buttonNumber]
        }

        chooseMenuTheme(menuTheme, index, readOnly) {
            if (readOnly) {
                return;
            }
            this.selected_menu_theme = index;

            let buttonColor = menuTheme.click;
            let backgroundColor = menuTheme.background;
            let hoverColor = menuTheme.hover;

            const head = document.getElementsByTagName('head')[0];
            const tabsElement = document.getElementById("menuActiveButton")
            if (tabsElement) {
                tabsElement.remove();
            }


            const style = document.createElement('style');
            const hoverCss = `.side-menu:hover{background-color: ${hoverColor}}`
            const backgroundCss = `.meevo-second-menu {background-color: ${backgroundColor} !important}`
            const menuButtoncss = `.menu_item_active{background-color: ${buttonColor} !important}`
            const mobileMenuBackground = `.meevo-second-menu-phone{background-color: ${backgroundColor} !important}`
            const compileCss = hoverCss + backgroundCss + menuButtoncss + mobileMenuBackground;

            style.type = 'text/css';
            style.id = "menuActiveButton";
            style.appendChild(document.createTextNode(compileCss));
            head.appendChild(style);

            this.respObj.css["menuTheme"] = compileCss;
            this.respObj["colors"]["menuClickedColor"] = menuTheme.click;
            this.respObj["colors"]["menuHoverColor"] = menuTheme.hover;
            this.respObj["colors"]["menuBackgroundColor"] = menuTheme.background;
        }


        taskbarColorChange(color) {
            //temp change of the color change
            let taskbar = document.getElementById('meevo-navbar');
            taskbar.style.setProperty(`transition`, 'background-color 0s')
            taskbar.style.setProperty(`background-color`, ` ${color}`, `important`)
            this.taskbarColor = color;
            this.respObj["colors"]["taskbarColor"] = color;

        }
        taskbarActiveTabChange(color) {

            const head = document.getElementsByTagName('head')[0];
            const tabsElement = document.getElementById("taskbarTabsStyle")
            if (tabsElement) {
                tabsElement.remove();
            }
            const style = document.createElement('style');
            const css = `.meevo-navbar .context-container.context-active{background-color: ${color}; transition: background-color 0s}`
            style.type = 'text/css';
            style.id = "taskbarTabsStyle"
            style.appendChild(document.createTextNode(css));
            head.appendChild(style);
            this.taskbarTabsColor = color;

        }

        public updateModel(): void {
            let businessTypeId = null;
            if (Model.Guard.isSomething(this.model.businessTypeDetail))
                businessTypeId = this.model.businessTypeDetail.id;
            else
                return;
            let uri = `/${Meevo.AppSettings.Default.API_ROOT}/${Meevo.AppSettings.Default.API_ENDPOINTS.holiday}` + '/' + businessTypeId;
            if (Model.Guard.isSomething(this.model.businessTypeDetail)) {
                this.model.businessTypeId = this.model.businessTypeDetail.id;

                let parameters = {
                    businessTypeId: this.model.businessTypeId
                }
                this.dataService.customMethodData(uri, 'GET', '', '').then((results: any) => {
                    let temp = this.model.businessTypeDetail;
                    this.model = results.data;
                    this.model.businessTypeDetail = temp;
                });
            }
        }

        protected sendCss(): angular.IPromise<any> {

            let uri = `/storagedrv/${this.tenantId}/styles/meevo.json`
            let taskbar = `.meevo-navbar {background-color: ${this.respObj.colors["taskbarColor"]} !important; transition: background-color ${this.transitionTime}}`;
            let taskbarTabs = `.meevo-navbar .context-container.context-active{background-color: ${this.respObj.colors["taskbarTabsColor"]};}`; //transition: background - color ${ this.transitionTime }


            let mobile_taskbar = `.meevo-navbar .desktop-dropdown .desk-drop-container{background-color: ${this.respObj.colors["taskbarColor"]} !important}; `;
            let mobile_taskbarTabs = `.meevo-navbar .desktop-dropdown .desk-drop-container .drop-item.context-active{ background-color: ${this.respObj.colors["taskbarTabsColor"]}};`;
            let mobileTabs = `@media (max-width: 599px), (max-width: 812px) and (orientation: landscape) { ${mobile_taskbarTabs} }`;
            let mobiletaskbar = `@media (max-width: 599px), (max-width: 812px) and (orientation: landscape) { ${mobile_taskbar} }`;

            const hoverCss = `.side-menu:hover{background-color: ${this.respObj["colors"]["menuHoverColor"]}}`
            const backgroundCss = `.meevo-second-menu {background-color: ${this.respObj["colors"]["menuBackgroundColor"]} !important}`
            const menuButtoncss = `.menu_item_active{background-color: ${this.respObj["colors"]["menuClickedColor"]} !important}`
            const compileMenuCss = hoverCss + backgroundCss + menuButtoncss;

            //css for the response object
            this.respObj.css["taskbarColors"] = taskbar;
            this.respObj.css["taskbarTabs"] = taskbarTabs;
            this.respObj.css["mobile_taskbarTabs"] = mobileTabs;
            this.respObj.css["mobile_taskbar"] = mobiletaskbar;
            this.respObj.css["menuThemeCss"] = compileMenuCss

            //colors for the response object
            this.respObj.colors["taskbarColor"] = this.taskbarColor;
            this.respObj.colors["taskbarTabsColor"] = this.taskbarTabsColor;
            this.respObj.colors["menuTheme"] = this.selected_menu_theme;

            this.previousColors.taskbarColor = this.taskbarColor;
            this.previousColors.taskbarTabsColor = this.taskbarTabsColor;
            this.previousColors.menuTheme = this.selected_menu_theme;

            this.previousColors = {
                taskbarColor: this.taskbarColor,
                taskbarTabsColor: this.taskbarTabsColor,
                menuTheme: this.selected_menu_theme,
            };


            let data = this.respObj;

            return this.dataService.customMethodData(uri, 'POST', data, '')
                .then((response) => response.data).catch((err: any) => { console.log("getThemeCss"); });
        }
    }
}
